// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"244":"54d7450b","259":"54a50571","312":"263e6b70","339":"7062c6b2","369":"056a1a09","398":"a82ed208","498":"3883d1bd","551":"529b7957","553":"a01cdaa1","629":"260951a5","640":"bfca2c2f","750":"6771172c","800":"d4e8416d"}[chunkId] + ".chunk.js";
};